import paul from "../../../../asset/paul-2.png";
import styleSheet from "./style.module.scss";
import { useSelector } from "react-redux";
import { getImageDetails } from "../../../../feature/image-slice";
import OrbAvatar from "../../../../shared/components/orb-avatar";
import SyTooltip from "../../../../shared/components/sy-tooltip";
import { useTranslation } from "react-i18next";

type CommentHeaderProps = {
  name: string;
  agoTime: string;
  img?: string;
  from?: any;
  fromImage?: any;
};

const CommentAvatarHeader = ({
  name,
  agoTime = "2h ago",
  img = paul,
  from,
  fromImage,
}: CommentHeaderProps) => {
  const imageDetails = useSelector(getImageDetails);
    const { t } = useTranslation();
  return (
    <div className="d-flex align-items-center">
      <div className=" d-flex col-9">
        <OrbAvatar
          file={img || imageDetails.default[0].img}
          className={styleSheet.avatar_style}
          online={true}
        />
        <p className="main-font text-white mohave-bold m-0 ps-3 pe-2">{name}</p>
        <p className="main-font text-white mohave-bold opacity-50 m-0">{`- ${agoTime}`}</p>
      </div>
       <SyTooltip title={from}>
      <div className=" d-flex col-3 align-items-center pointer">
        <p className="font-15 text-white mohave-bold opacity-25 m-0 ">{`${t('from')}-`}</p>
        {fromImage && (
          <img
            className={`${styleSheet.image} rounded-circle ms-1`}
            src={fromImage}
          />
        )}
        <p className="font-15 text-white mohave-bold opacity-25 m-0 ms-1 truncate-1-lines">{`${from}`}</p>
      </div>
      </SyTooltip>
    </div>
  );
};

export default CommentAvatarHeader;
